// Theme configuration for different clients
export const themes = {
	blue: {
		name: "Blue Theme",
		colors: {
			primary: "#1059bf",
			primaryDark: "#0b1f42",
			primaryLight: "#1cc1ff",
			primaryGradient: "linear-gradient(135deg, #1059bf 0%, #0b1f42 100%)",
			primaryGradientLight: "linear-gradient(135deg, #1059bf 0%, #1cc1ff 100%)",
			primaryHover: "#0d4aa0",
			primaryActive: "#093580",
			primaryAlpha: {
				5: "rgba(16, 89, 191, 0.05)",
				8: "rgba(16, 89, 191, 0.08)",
				10: "rgba(16, 89, 191, 0.1)",
				12: "rgba(16, 89, 191, 0.12)",
				15: "rgba(16, 89, 191, 0.15)",
				20: "rgba(16, 89, 191, 0.2)",
				25: "rgba(16, 89, 191, 0.25)",
				30: "rgba(16, 89, 191, 0.3)",
				40: "rgba(16, 89, 191, 0.4)",
			},
			primaryLightAlpha: {
				20: "rgba(28, 193, 255, 0.2)",
				35: "rgba(28, 193, 255, 0.35)",
				50: "rgba(28, 193, 255, 0.5)",
				90: "rgba(28, 193, 255, 0.9)",
			},
		},
	},
	green: {
		name: "Green Theme",
		colors: {
			primary: "#059669",
			primaryDark: "#064e3b",
			primaryLight: "#10b981",
			primaryGradient: "linear-gradient(135deg, #059669 0%, #064e3b 100%)",
			primaryGradientLight: "linear-gradient(135deg, #059669 0%, #10b981 100%)",
			primaryHover: "#047857",
			primaryActive: "#065f46",
			primaryAlpha: {
				5: "rgba(5, 150, 105, 0.05)",
				8: "rgba(5, 150, 105, 0.08)",
				10: "rgba(5, 150, 105, 0.1)",
				12: "rgba(5, 150, 105, 0.12)",
				15: "rgba(5, 150, 105, 0.15)",
				20: "rgba(5, 150, 105, 0.2)",
				25: "rgba(5, 150, 105, 0.25)",
				30: "rgba(5, 150, 105, 0.3)",
				40: "rgba(5, 150, 105, 0.4)",
			},
			primaryLightAlpha: {
				20: "rgba(16, 185, 129, 0.2)",
				35: "rgba(16, 185, 129, 0.35)",
				50: "rgba(16, 185, 129, 0.5)",
				90: "rgba(16, 185, 129, 0.9)",
			},
		},
	},
	purple: {
		name: "Purple Theme",
		colors: {
			primary: "#7c3aed",
			primaryDark: "#4c1d95",
			primaryLight: "#a78bfa",
			primaryGradient: "linear-gradient(135deg, #7c3aed 0%, #4c1d95 100%)",
			primaryGradientLight: "linear-gradient(135deg, #7c3aed 0%, #a78bfa 100%)",
			primaryHover: "#6d28d9",
			primaryActive: "#5b21b6",
			primaryAlpha: {
				5: "rgba(124, 58, 237, 0.05)",
				8: "rgba(124, 58, 237, 0.08)",
				10: "rgba(124, 58, 237, 0.1)",
				12: "rgba(124, 58, 237, 0.12)",
				15: "rgba(124, 58, 237, 0.15)",
				20: "rgba(124, 58, 237, 0.2)",
				25: "rgba(124, 58, 237, 0.25)",
				30: "rgba(124, 58, 237, 0.3)",
				40: "rgba(124, 58, 237, 0.4)",
			},
			primaryLightAlpha: {
				20: "rgba(167, 139, 250, 0.2)",
				35: "rgba(167, 139, 250, 0.35)",
				50: "rgba(167, 139, 250, 0.5)",
				90: "rgba(167, 139, 250, 0.9)",
			},
		},
	},
	orange: {
		name: "Orange Theme",
		colors: {
			primary: "#ea580c",
			primaryDark: "#9a3412",
			primaryLight: "#fb923c",
			primaryGradient: "linear-gradient(135deg, #ea580c 0%, #9a3412 100%)",
			primaryGradientLight: "linear-gradient(135deg, #ea580c 0%, #fb923c 100%)",
			primaryHover: "#c2410c",
			primaryActive: "#9a3412",
			primaryAlpha: {
				5: "rgba(234, 88, 12, 0.05)",
				8: "rgba(234, 88, 12, 0.08)",
				10: "rgba(234, 88, 12, 0.1)",
				12: "rgba(234, 88, 12, 0.12)",
				15: "rgba(234, 88, 12, 0.15)",
				20: "rgba(234, 88, 12, 0.2)",
				25: "rgba(234, 88, 12, 0.25)",
				30: "rgba(234, 88, 12, 0.3)",
				40: "rgba(234, 88, 12, 0.4)",
			},
			primaryLightAlpha: {
				20: "rgba(251, 146, 60, 0.2)",
				35: "rgba(251, 146, 60, 0.35)",
				50: "rgba(251, 146, 60, 0.5)",
				90: "rgba(251, 146, 60, 0.9)",
			},
		},
	},
	yellow: {
		name: "Yellow Theme",
		colors: {
			primary: "#eee221",
			primaryDark: "#b8a01a",
			primaryLight: "#f5e85a",
			primaryGradient: "linear-gradient(135deg, #eee221 0%, #b8a01a 100%)",
			primaryGradientLight: "linear-gradient(135deg, #eee221 0%, #f5e85a 100%)",
			primaryHover: "#d4c61e",
			primaryActive: "#b8a01a",
			primaryAlpha: {
				5: "rgba(238, 226, 33, 0.05)",
				8: "rgba(238, 226, 33, 0.08)",
				10: "rgba(238, 226, 33, 0.1)",
				12: "rgba(238, 226, 33, 0.12)",
				15: "rgba(238, 226, 33, 0.15)",
				20: "rgba(238, 226, 33, 0.2)",
				25: "rgba(238, 226, 33, 0.25)",
				30: "rgba(238, 226, 33, 0.3)",
				40: "rgba(238, 226, 33, 0.4)",
			},
			primaryLightAlpha: {
				20: "rgba(245, 232, 90, 0.2)",
				35: "rgba(245, 232, 90, 0.35)",
				50: "rgba(245, 232, 90, 0.5)",
				90: "rgba(245, 232, 90, 0.9)",
			},
		},
	},
};

// Get current theme from environment variable or localStorage, default to blue
export const getCurrentTheme = () => {
	const themeName =
		process.env.REACT_APP_THEME ||
		localStorage.getItem("app-theme") ||
		"blue";
	return themes[themeName] || themes.blue;
};

// Apply theme to CSS variables
export const applyTheme = (themeName = null) => {
	const theme = themeName ? themes[themeName] || themes.blue : getCurrentTheme();
	const root = document.documentElement;

	// Set CSS variables
	root.style.setProperty("--color-primary", theme.colors.primary);
	root.style.setProperty("--color-primary-dark", theme.colors.primaryDark);
	root.style.setProperty("--color-primary-light", theme.colors.primaryLight);
	root.style.setProperty("--color-primary-hover", theme.colors.primaryHover);
	root.style.setProperty("--color-primary-active", theme.colors.primaryActive);

	// Set alpha variants
	Object.keys(theme.colors.primaryAlpha).forEach((key) => {
		root.style.setProperty(
			`--color-primary-alpha-${key}`,
			theme.colors.primaryAlpha[key],
		);
	});

	// Set primaryLight alpha variants
	if (theme.colors.primaryLightAlpha) {
		Object.keys(theme.colors.primaryLightAlpha).forEach((key) => {
			root.style.setProperty(
				`--color-primary-light-alpha-${key}`,
				theme.colors.primaryLightAlpha[key],
			);
		});
	}

	// Store theme name
	if (themeName) {
		localStorage.setItem("app-theme", themeName);
	}
};

